<template>
  <div>
    <svg class="svg" xmlns="http://www.w3.org/2000/svg" :viewBox="computedViewBox">
      <g v-if="showIcon" class="icon">
        <path d="M.1 71.4l-.1.1h50.2V18.3l1.5 1.5.1.1 19.7 19.7V0l-.1.1A76.3 76.3 0 00.1 71.4z" fill="#fb5a09" />
        <path d="M152.1 71.5h.1l-.1-.1A76.2 76.2 0 0080.8.1l-.1-.1v48.7l22.8 22.8h48.6z" fill="#8236ec" />
        <path d="M152.1 80.7h-39.4l7.1 7.1-27.3-.5 16.9 42-22.5 9.1-6.1-15.3V152l.1-.1a76.2 76.2 0 0071.3-71.3l.1-.1h-.2z" fill="#14991f" />
        <path d="M50.2 116.4V80.7H0l.1.1a76.2 76.2 0 0071.3 71.3l.1.1v-51.6l-1.7-4.3-19.6 20.1z" fill="#3884ff" />
      </g>

      <path
        v-if="showName"
        class="name"
        :class="computedClass"
        d="M700 113.6l2.8 1 14.3 5.2c.3 0 .7.2 1 .4 1.1.5 1.5 1.3 1.3 2.5a26.6 26.6 0 01-4 9.7c-1 1.3-2 1.7-3.6 1.1l-13.8-5.3-32.7-13a31 31 0 01-13.4-9.6 37.3 37.3 0 01-6.7-14 62.5 62.5 0 01-1.8-15.8c0-5.5.5-11 2-16.4a31.8 31.8 0 0124.7-24.1 50.2 50.2 0 0128.2 2.2 30 30 0 0113.2 11.2 42.2 42.2 0 016.2 18c.7 5.5.8 11.1.2 16.7-.6 6-2.1 11.9-5 17.3-2.8 5-6.7 8.9-11.6 11.7l-1.4 1 .1.2zm0-37.6l-.7-7.8c-.4-3.4-1.3-6.6-3-9.7-1.9-3.8-4.8-6.5-9-7.9-3.2-1-6.5-1.2-9.9-.7-4.8.7-8.5 3-11.1 7.1-2.6 4-3.7 8.6-4.1 13.3-.5 4.5-.4 8.9.2 13.3.5 3.6 1.4 7 3 10.3 2.2 4 5.3 6.9 9.8 8.2 2.7.8 5.5.9 8.3.6 4-.4 7.5-2 10.3-5.1 2-2.3 3.3-5 4.2-8a51 51 0 002-13.6zM543.8 63.5l.7-.7a21.8 21.8 0 0124.9-6.5c3 1.1 5 3.3 6.5 6.1l.4 1h.2l3.6-3.3a23.4 23.4 0 0122-4.1c3.8 1.3 6.5 4 8 7.8.9 2.6 1.4 5.3 1.4 8V113c0 2-1 3-2.4 3.5-1 .2-2 .5-2.9.5h-7c-1 0-2-.4-3-.7-1.2-.5-2-1.5-2-3V112 77.3l-.1-2.6c-.5-4-2.6-5.3-5.9-5.6-3.3-.3-6 1-8 3.6l-.2.2a7.5 7.5 0 00-2 5.5c.2 11.4.1 22.7.1 34 0 2.6-.9 3.9-3.5 4.2-2.4.4-4.8.3-7.2.3-1.1 0-2.2 0-3.3-.3-.7-.1-1.4-.4-2-.8a2.5 2.5 0 01-1.3-2V112 77.6l-.1-2.6c-.5-4.4-2.8-5.6-6-5.9-3-.2-5.3 1-7.3 3l-1.3 1.5a6.4 6.4 0 00-1.4 4.3v34.6c0 2.5-.9 3.6-3.4 4.1-2.4.6-4.8.4-7.3.3-1 0-2.2 0-3.3-.3a6 6 0 01-1.8-.7 2.7 2.7 0 01-1.5-2.3V112 81.6c0-4.7-.2-9.3-.4-14-.1-2-.5-4-.9-6-.4-2.4 0-3.1 2.3-4 3.4-1 7-1.4 10.6-1.5 1.6 0 2.8.7 3.3 2.2l1.2 4 .3 1.3zM883 88v24.4c0 2.6-.9 3.9-3.5 4.2-2.4.4-4.8.3-7.2.3-1.1 0-2.3 0-3.4-.3a7 7 0 01-2-.9c-.7-.4-1-1-1.2-1.8v-1.6-78.7-.5c0-2.2.7-3.2 2.9-3.9l1-.2c3.3-.4 6.5-.4 9.7 0l1.8.7c1.2.6 1.9 1.5 1.9 3v46l.3.1.8-1c4.3-6.4 8.6-12.7 12.8-19.2 1.3-2 3-2.8 5.4-3 3.3-.2 6.7-.2 10 0a9 9 0 012.3.6c1 .4 1.2 1 .8 2l-.7 1-16 23-.4.5.7 1.2 17.8 28c.5.8 1 1.6 1.3 2.4.4 1 .1 1.7-.9 2l-2.9.6h-9.8c-.8 0-1.6-.2-2.4-.4-1.3-.3-2-1.1-2.8-2.2l-15.2-25.1c-.3-.4-.4-1-1-1.2zM386.9 88.1V113c0 1.8-1 2.9-2.5 3.4-.9.3-1.8.5-2.7.5h-7.1c-1 0-2.1-.4-3.1-.7a3 3 0 01-2-3V112 33.8v-.4c-.2-2.8 1.2-3.8 3.5-4.3 1-.2 2.2-.3 3.3-.3 2.3 0 4.5.1 6.7.3.5 0 1 .2 1.6.4 1.4.6 2.2 1.6 2.2 3.2v46.1h.3l.8-1 12.9-19.2c1.2-2 3-2.8 5.1-3 3.4-.2 6.7-.2 10.1.1l2.4.6c1 .3 1.2 1 .8 1.9l-.7 1.1-16 23-.4.5.7 1.1c6 9.3 11.8 18.6 17.7 28l1.4 2.5c.4 1 .1 1.6-.9 2-.9.3-1.9.5-2.9.5h-10l-2.2-.3a4.5 4.5 0 01-2.8-2.3l-15.2-25-.8-1.3-.3.1zM228.7 118c-5-.3-10-.7-14.7-2.1a29 29 0 01-20.8-20.5 66 66 0 01-2.6-20.4c0-5.2.5-10.5 1.9-15.6a34.1 34.1 0 017.6-14.6c3.3-3.6 7.2-6.1 11.7-7.8a60.7 60.7 0 0126.4-2.2c4 .6 8 1.4 11.7 3.2 1 .5 2 1 2.8 1.7 1.2 1 1.7 2.3 1.3 3.7-1 3.6-2.9 6.6-5.6 9-1 1-2 1-3.2.5a35.7 35.7 0 00-22.5-2.5c-5 1.3-8.6 4.5-10.7 9.2a32.8 32.8 0 00-2.7 11.5c-.3 4.3-.3 8.7.4 13 .6 3.9 1.7 7.6 4 10.9 2.6 4 6.3 6.2 11 7 5.6.9 11 .3 16.5-1.6l5.5-2.2c1.8-.7 3.1-.4 4.4 1 2 2.3 3.2 5 3.9 7.9.4 1.7-.2 3.1-1.4 4.3a14.1 14.1 0 01-4.9 3 41.5 41.5 0 01-11.2 2.7l-8.8.9zM484.6 91.8a14 14 0 003.1 8.7 11 11 0 006.7 3.3c4.5.7 8.8 0 13-1.6l3.3-1.4c1.3-.6 2.4-.3 3.3.7 1.9 1.9 3.2 4.2 4 6.8.5 1.8-.3 3.3-1.7 4.5-1.9 1.4-4 2.2-6.2 2.9a42 42 0 01-27.7-.5c-5.9-2.4-10-6.6-12.6-12.3a35 35 0 01-3.1-13.5c-.2-4.7 0-9.4 1-14a25 25 0 017.6-14 24 24 0 019.4-5.1 35 35 0 0117-.8c5.4 1 9.6 4 13 8.4 2.4 3.4 3.7 7.2 4.6 11.2.7 3 .9 6 1 9.1 0 1-.2 2-.8 2.7-1 1.4-2.2 2.7-3.4 4-.7.7-1.6 1-2.6 1l-27.4-.1h-1.5zm0-11.6h18.7c.1-3-.4-5.7-1.8-8.2a6.4 6.4 0 00-3.3-3 8.8 8.8 0 00-9 1.4c-3.1 2.4-4 6-4.6 9.8zM760.4 109c-1.6 2-3.2 3.5-5 4.8a21 21 0 01-10.9 4c-3 0-6-.2-8.8-1.1-4-1.3-6.8-4-8.3-8a25 25 0 01-1.5-7.5v-3.9-37c0-2.2.2-3.8 3.5-4.4a31 31 0 0110.7 0c2.2.6 3 1.7 3 4v35l.1 2c.1.8.2 1.7.5 2.5a5 5 0 003.9 3.8 9 9 0 009-2.6l1.2-1.3c1.2-1.3 1.8-2.9 1.8-4.8V60.4c0-3 .6-4 3.5-4.5a29.7 29.7 0 0110.6 0c2.3.6 3.1 1.6 3.1 4v32.8c0 6.4.2 12.9 1.3 19.3.3 1.7 0 2.3-1.7 3-2.1 1-4.4 1.3-6.7 1.6-1.5.2-3 .2-4.6.3-1.4 0-2.4-.6-3-1.8-.8-1.6-1-3.4-1.5-5.1l-.2-1zM810.7 86.8c.1-4.7.5-9.2 1.7-13.5 1.6-5.2 4.1-9.7 8.5-13 3.2-2.4 6.8-3.8 10.7-4.6 4.7-1 9.4-1 14.1-.6 3.3.4 6.5 1 9.5 2.4 1.2.6 2.4 1.3 3.4 2.2a4 4 0 011.2 4.8c-.9 2.3-2.2 4.4-4 6.2-1.1 1.4-1.7 1.4-3.4.6a24 24 0 00-7-2.6c-3.2-.5-6.4-.5-9.4.8a9.8 9.8 0 00-5.4 5.1c-1.1 2.4-1.7 5-1.9 7.7-.3 4-.2 8.2.7 12.2.5 2.1 1.2 4 2.6 5.8 1.6 1.9 3.6 3 6 3.4 4.6.8 9 0 13.3-1.8l2.3-1c1-.4 1.8-.2 2.6.4l1 1c1.4 1.6 2.5 3.5 3.2 5.7.6 2 .1 3.7-1.5 5-.7.6-1.6 1-2.5 1.5-3.1 1.4-6.3 2.2-9.7 2.7l-4.2.5c-4.3.3-8.5 0-12.7-1a22.7 22.7 0 01-13.1-8.1 27.7 27.7 0 01-5-11.6c-.7-3.4-.9-7-1-10.2zM314.6 86.7c0-4.5.4-8.8 1.6-13a22.8 22.8 0 0115.5-17c4.5-1.5 9.2-2 14-1.8 3.8 0 7.6.6 11.3 1.8 1.7.6 3.4 1.3 4.8 2.4a8 8 0 011.6 1.7c.7 1 .8 2 .4 3.2-.8 2.6-2.3 5-4.2 7-1.2 1.1-1.7 1.1-3.2.4a24 24 0 00-7.2-2.6 17 17 0 00-9.6.8c-2.3 1-4 2.6-5 4.9-1.2 2.3-1.7 4.9-2 7.5a41 41 0 000 8.6c.3 2.5.7 4.9 1.7 7.2 1.6 3.4 4 5.4 7.7 6 4.6.7 9 0 13.2-1.9l2.4-1c.8-.4 1.7-.2 2.4.4l1.4 1.4c1.3 1.7 2.3 3.5 3 5.6a4 4 0 01-1.3 4.4c-.8.7-1.7 1.3-2.6 1.7-3 1.5-6.4 2.3-9.8 2.8l-4.3.5a40 40 0 01-12.7-1 22.9 22.9 0 01-17.5-17 47.7 47.7 0 01-1.6-13zM260.4 67.3V33.7c0-3 1.2-4.2 4-4.6 1-.2 2.2-.3 3.3-.3 2.1 0 4.3.1 6.4.3.6 0 1.3.3 2 .6a3 3 0 011.7 2.8V98c0 1 0 2 .2 3.1.3 1.8 1.4 2.8 3.2 2.9l3.1-.3c1.3-.1 1.8 0 2.5 1.2 1.1 2.2 1.7 4.6 2 7 0 1.7-.7 3-2 4a10.8 10.8 0 01-5.3 1.7c-3 .3-6.1.3-9.1-.4a13.9 13.9 0 01-10.9-10.1c-.9-3-1-6-1-9.1V67.3zM803.7 86.3v26c0 2.7-.9 4-3.5 4.3-2.4.4-4.8.3-7.1.3a22 22 0 01-3.3-.3c-.6 0-1-.2-1.6-.5a3 3 0 01-1.8-2.6v-1.3-51.9-1c0-1.6.8-2.7 2.3-3 1.1-.4 2.2-.6 3.3-.7 2.8-.2 5.6-.2 8.3.3l1.5.5a3 3 0 011.9 2.8v27.1zM292.9 86.3V60.4v-1a3 3 0 012.2-3.1A28.6 28.6 0 01307 56c.7 0 1.3.4 1.9.7.8.5 1.3 1.2 1.3 2.2V112.5c.3 2.8-1.3 3.7-3.3 4.2l-2.6.2H298c-1.1 0-2.2-.4-3.2-.8a2.8 2.8 0 01-2-2.8v-1.2-25.8zM450 54.8a37.2 37.2 0 019.3-21.7c1-1.3 2.4-2.5 3.8-3.5 2.2-1.7 4.7-1.3 7-.3 1 .4 1.4 1.3 1.2 2.3l-.6 2.3-3.2 9.7a29 29 0 00-1.1 7.3l-.2 4.7c0 3.2-1.8 4.9-4.9 5.3-2 .3-4.3.3-6.4 0-1-.2-1.8-.5-2.7-1-1.4-.7-2.1-2-2.2-3.6v-1.5zM803.7 37.4v4.3c0 1.8-.8 2.9-2.5 3.5a8 8 0 01-2.3.4c-3 .1-6 .3-9-.1l-.7-.2c-2-.6-2.9-1.7-2.9-3.8v-7.1-1.6c0-1.7.9-2.9 2.5-3.4l3-.6h6.5c1.1 0 2.2.4 3.3.8 1.4.5 2.1 1.6 2.1 3.1v4.6zM310.2 37.3v4.4c0 2-.8 3-2.7 3.5l-2.6.5H298c-1 0-1.9-.3-2.8-.5-1.6-.6-2.4-1.6-2.4-3.4v-9c0-1.7.8-2.8 2.3-3.3 1-.3 2-.6 2.9-.6h6.8c1 0 2 .3 3 .6 1.5.5 2.3 1.6 2.3 3.3v4.5z"
      />
    </svg>
    <h1 v-if="showName" class="sr-only">Click &lsquo;em Quick</h1>
  </div>
</template>

<script>
import {LOGO_COLOR_LIST} from './../constants/globalConstants';

export default {
  name: 'Logo',
  props: {
    doRandomColorAnimation: {
      type: Boolean,
      default: true,
    },
    color: {
      type: String,
      default: '',
    },
    showIcon: {
      type: Boolean,
      default: true,
    },
    showName: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      colorList: LOGO_COLOR_LIST,
      startingColor: '',
    };
  },
  watch: {},
  computed: {
    computedClass: function() {
      if (this.doRandomColorAnimation) {
        return `name--start-with-${this.startingColor}`;
      } else {
        return `name--${this.color}`;
      }
    },
    computedViewBox: function() {
      if (this.showName) {
        if (this.showIcon) {
          return '0 0 918.3 152.2';
        } else {
          return '185 0 745.3 152.2';
        }
      } else {
        if (this.showIcon) {
          return '0 0 152.2 152.2';
        } else {
          return '0 0 0 0';
        }
      }
    },
  },
  created() {
    if (this.doRandomColorAnimation) {
      if (this.color) {
        this.startingColor = this.color;
      } else {
        const randomIndex = Math.floor(Math.random() * Math.floor(this.colorList.length));
        this.startingColor = this.colorList[randomIndex];
      }
    }
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
.svg {
  height: auto;
  width: 100%;

  .name {
    animation-delay: 0s;
    animation-direction: normal;
    animation-duration: 60s;
    animation-fill-mode: none;
    animation-iteration-count: infinite;
    animation-play-state: running;
    animation-timing-function: linear;
    fill: white;

    /* Fixed color */

    &--white {
      animation-play-state: paused;
      fill: var(--color-white);
    }

    &--black {
      animation-play-state: paused;
      fill: var(--color-black);
    }

    &--yellow {
      animation-play-state: paused;
      fill: var(--color-yellow);
    }

    &--orange {
      animation-play-state: paused;
      fill: var(--color-orange);
    }

    &--pink {
      animation-play-state: paused;
      fill: var(--color-pink);
    }

    &--violet {
      animation-play-state: paused;
      fill: var(--color-violet);
    }

    &--blue {
      animation-play-state: paused;
      fill: var(--color-blue);
    }

    &--green {
      animation-play-state: paused;
      fill: var(--color-green);
    }

    &--teal {
      animation-play-state: paused;
      fill: var(--color-teal);
    }

    &--brown {
      animation-play-state: paused;
      fill: var(--color-brown);
    }

    /* Animated */

    &--start-with-yellow {
      animation-name: color-cycle--start-with-yellow;
    }
    &--start-with-orange {
      animation-name: color-cycle--start-with-orange;
    }
    &--start-with-pink {
      animation-name: color-cycle--start-with-pink;
    }
    &--start-with-violet {
      animation-name: color-cycle--start-with-violet;
    }
    &--start-with-blue {
      animation-name: color-cycle--start-with-blue;
    }
    &--start-with-green {
      animation-name: color-cycle--start-with-green;
    }
    &--start-with-teal {
      animation-name: color-cycle--start-with-teal;
    }
    &--start-with-brown {
      animation-name: color-cycle--start-with-brown;
    }
  }
}
</style>
